import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const H1 = styled.h1`
  font-family: ${props => props.theme.fontFamilyHeader};
  font-size: ${props => (props.theme.isPortrait ? 30 : 44)}px;
  line-height: ${props => (props.theme.isPortrait ? 40 : 57)}px;
  width: ${props => (props.theme.isPortrait ? '85vw' : 'auto')};
  color: #fff;
  margin: ${props => (props.theme.isPortrait ? '24px 0 18px 0' : '40px 0')};
`;

export default function Title({ text }) {
  return <H1>{text}</H1>;
}

Title.propTypes = {
  text: PropTypes.string.isRequired,
};
